module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('div', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }), _c('em', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "center sans"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454928003_epub_itr_r1#itr"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454928003_epub_c01_r1#c01"
    }
  }, [_c('em', [_vm._v("Chapter One")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("ANTIPASTI")])]), _c('br'), _c('em', [_vm._v("(Antipasti)")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454928003_epub_c02_r1#c02",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter Two")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("PASTAS AND RISOTTOS")])]), _c('br'), _c('em', [_vm._v("(Primi Piatti)")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454928003_epub_c03_r1#c03",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter Three")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("SOUPS")])]), _c('br'), _c('em', [_vm._v("(Minestre)")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454928003_epub_c04_r1#c04",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter Four")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("SIDE DISHES")])]), _c('br'), _c('em', [_vm._v("(Contorni)")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454928003_epub_c05_r1#c05",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter Five")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("MEATS AND SEAFOOD")])]), _c('br'), _c('em', [_vm._v("(Secondi Piatti)")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454928003_epub_c06_r1#c06",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter Six")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("DESSERTS")])]), _c('br'), _c('em', [_vm._v("(Dolci)")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454928003_epub_c07_r1#c07",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter Seven")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("SAUCES, CONDIMENTS, AND PRESERVES")])]), _c('br'), _c('em', [_vm._v("(Salse, Condimenti e Conserve)")])])]), _vm._v(" "), _c('p', {
    staticClass: "center sans"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454928003_epub_bm1_r1#bm1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("IN THE END")])])]), _vm._v(" "), _c('p', {
    staticClass: "center sans"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454928003_epub_ack_r1#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "center sans"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454928003_epub_bm2_r1#bm2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("METRIC CHART")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0b3a444","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781454928003_epub_toc_r1.vue
// module id = 75
// module chunks = 0